import { useState, useEffect, useCallback } from 'react';

export default function usePdfFullscreen({ viewerRootRef }) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
      setIsFullscreen(!!fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    handleFullscreenChange();

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
    };
  }, []);

  const toggleFullscreen = useCallback(() => {
    const rootEl = viewerRootRef.current;
    if (!rootEl) return;

    const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
    if (fullscreenElement) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      return;
    }

    if (rootEl.requestFullscreen) rootEl.requestFullscreen();
    else if (rootEl.webkitRequestFullscreen) rootEl.webkitRequestFullscreen();
  }, [viewerRootRef]);

  return {
    isFullscreen,
    toggleFullscreen,
  };
}
